export const ChatTypingDots = () => (
  <span
    role="status"
    aria-label="Assistant is replying"
    className="flex h-5 items-center gap-1"
  >
    {[0, 200, 400].map((delay) => (
      <span
        key={delay}
        className="size-1 rounded-full bg-accent-teal-bold motion-safe:animate-pulse"
        style={{ animationDelay: `${delay}ms` }}
      />
    ))}
  </span>
);
